// removed by extract-text-webpack-plugin
module.exports = {"headline":"TOE5I7skNlgyZ7bNw4EUH","small":"_2JZxKCTcKoom14ooVan_5","medium":"BeTWOQ9c_Rl8diSVJJBxU","large":"_2F8bsB27ZBigctuiE63Szc","dark":"_2JP4_0ljdPNBpYKyXdoPfR"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/text/Headline.css
// module id = 303
// module chunks = 0